
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/refute-rumors",
      function () {
        return require("private-next-pages/newsroom/refute-rumors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/refute-rumors"])
      });
    }
  